import Typography from '@alltrails/core/components/Typography';
import { useIntl } from 'react-intl';
import styles from './styles/styles.module.scss';

type CardGridSectionProps = {
  header: React.ReactNode;
  subheader?: React.ReactNode;
  children: React.ReactNode[];
  cardMetadata?: Array<{ title: string; ariaLabel?: string }>;
};

const CardGridSection = ({ header, subheader, children, cardMetadata }: CardGridSectionProps) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <Typography component="h2" variant="heading500" className={styles.header}>
        {header}
      </Typography>
      {subheader && (
        <Typography className={styles.subheader} variant="paragraph300">
          {subheader}
        </Typography>
      )}
      <div className={styles.cardsContainer}>
        {children.map((child, index) => {
          const metadata = cardMetadata?.[index];
          const ariaLabel = metadata?.ariaLabel || 
            intl.formatMessage({ defaultMessage: 'Press item' });

          return (
            <div key={index} role="group" aria-label={ariaLabel} className={styles.cardWrapper}>
              {child}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CardGridSection;
